import React, { Component } from 'react';

class Skeleton extends Component{
    constructor(props){
        super(props)
        this.state={
            proList: Array(5).fill(1)
        }
    }

    render(){
        return(
            <div className='skeleton-cart-list'>
                {
                    this.state.proList.map((item, index)=>{
                        return (
                            <div key={index} className='skeleton-list-item'>
                                <div className='skeleton-item-img'></div>
                                <div className='skeleton-item-line'></div>
                                <div className='skeleton-item-line'></div>
                            </div>
                        )
                    })
                }        
            </div>    
        )
    }
}

export default Skeleton